import { styled } from "@mui/material/styles";

const PREFIX = "ConfigurationForm";
export const classes = {
  button: `${PREFIX}-button`,
  divider: `${PREFIX}-divider`,
  radio: `${PREFIX}-radio`,
  field: `${PREFIX}-field`,
  secretsTitle: `${PREFIX}-secretsTitle`,
  secretsText: `${PREFIX}-secretsText`,
  checkboxHelperText: `${PREFIX}-checkboxHelperText`,
  threatResponseBox: `${PREFIX}-threatResponseBox`,
};

export const Root = styled("form")(({ theme }) => ({
  [`& .${classes.button}`]: {
    margin: theme.spacing(0, 0, 0, 1),
  },
  [`& .${classes.divider}`]: {
    margin: theme.spacing(1, 0),
  },
  [`& .${classes.radio}`]: {
    marginBottom: theme.spacing(0),
  },
  [`& .${classes.field}`]: {
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.secretsTitle}`]: {
    fontWeight: "bold",
  },
  [`& .${classes.secretsText}`]: {
    fontSize: ".85rem",
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.checkboxHelperText}`]: {
    marginTop: -15,
    fontSize: ".85rem",
    fontWeight: "bold",
    color: theme.palette.error.main,
  },
  [`& .${classes.threatResponseBox}`]: {
    border: `2px solid ${theme.palette.common.white}`,
    marginTop: 0,
    marginBottom: theme.spacing(4),
    p: {
      marginBottom: 8,
    },
    "& .MuiList-root": {
      listStyleType: "disc",
      marginBottom: 8,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 8,
      paddingBottom: 0,
      paddingLeft: 24,
      paddingRight: 0,
      paddingTop: 0,
      "& .MuiListItem-root": {
        display: "list-item",
        margin: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingTop: 0,
      },
    },
  },
}));
